import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Zoom from "@material-ui/core/Zoom";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiButton from "../MuiButton/MuiButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import infoErrorIcon from "Assets/svg/icon/infoErrorIcon.svg";
import infoWarning from "Assets/svg/icon/warning-sign.svg";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { object } from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});

export default function AlertDialog({
  showAlert,
  onClose,
  type,
  onClickOk,
  okTitle,
  cancelTitle,
  relationText,
  questionText,
  relationData,
  exp,
  loading,
}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  return (
    <div>
      <Dialog
        dir={direction}
        open={showAlert}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        className={type}
        maxWidth={"xs"}
      >
        <DialogTitle>
          {loading && <CircularProgress size={50} />}
          {!loading && type === "alertError" && (
            <ReactSVG src={infoErrorIcon} />
          )}
          {!loading && type === "alertWarning" && (
            <div className="text-warning">
              <ReactSVG src={infoWarning} />
            </div>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {relationData ? relationText : questionText}
          </DialogContentText>
          {exp && (
            <div className="alert-dialog-exp">
              {Object.keys(exp).map((key, index) => {
                return (
                  <p key={`alert-dialog-exp-${index}`}>
                    <Icons.Dash className="ms-1" />
                    {`${t(key)} :`}
                    <strong className="me-1">{exp[key]}</strong>
                  </p>
                );
              })}
            </div>
          )}
          {relationData ? (
            <List disablePadding className={"relationData"}>
              {relationData.map((item) => {
                return (
                  <ListItem key={item.Id}>
                    <ListItemText
                      primary={`${t("name")} : ${item.Name}`}
                      secondary={`${t("Shomare")} : ${item.Id}`}
                    />
                  </ListItem>
                );
              })}
            </List>
          ) : null}
        </DialogContent>
        <DialogActions className="border-0">
          <MuiButton
            title={okTitle}
            onClick={onClickOk}
            innerIcon={
              type === "alertWarning" ? (
                <Icons.ExclamationTriangle size={17} />
              ) : type === "alertError" ? (
                <Icons.Trash3 size={17} />
              ) : null
            }
            className={`${type === "alertWarning" && "MuiButton-warning"} ${
              type === "alertError" && "MuiButton-danger"
            } w-100`}
            disabled={relationData?.length > 0}
          />
          <MuiButton title={cancelTitle} onClick={onClose} />
        </DialogActions>
      </Dialog>
    </div>
  );
}
